/**
 * @file IP信息报错
 * @author hukeke01
 */

import {rcAjax, getAcsToken} from '../util';
import {
    GET_IP_INFO,
    SUBMIT_IP_INFO,
    GET_USER_INFO,
    GET_IP_LIST,
    GET_IP_DETAIL
} from './ActionTypes';

export function fetchIpInfo(dispatch, params) {
    return rcAjax('GET', '/haoma/business/ip/info?ip=' + params, {}, {}, (data = {}) => {
        dispatch({type: GET_IP_INFO, data: data.data});
    });
}

export async function submitIpAppeal(dispatch, params) {
    // 获取接口签名Acs-Token放入请求头
    const token = await getAcsToken();
    return rcAjax('POST', '/haoma/business/ip/report', {}, params, (data = {}) => {
        dispatch({type: SUBMIT_IP_INFO, data: data.data});
    }, {'Acs-Token': token});
}

export function fetchIpUserInfo(dispatch) {
    return rcAjax('GET', '/haoma/business/user', {}, {}, (data = {}) => {
        dispatch({type: GET_USER_INFO, data: data.data});
    });
}

export function fetchIpDetailList(dispatch, params) {
    return rcAjax('GET', '/haoma/business/ip/feedback/list?' + params, {}, {}, (data = {}) => {
        dispatch({type: GET_IP_LIST, data: data.data});
    });
}

export function fetchIpDetail(dispatch, params) {
    return rcAjax('GET', '/haoma/business/ip/feedback/detail?id=' + params, {}, {}, (data = {}) => {
        dispatch({type: GET_IP_DETAIL, data: data.data});
    });
}